import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "desc", "selected", "value", "onClick", "dividerNeeded"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Accordion/Accordion.js",
  _this = this;
import React, { useState } from 'react';
import { Transition } from 'react-transition-group';
import { ArrowUp, ArrowDown } from '@dls/assets/icons';
import { noop, testIdProps } from '../../helpers';
import { resizeIcon } from '../../helpers/utils';
import Divider from '../Divider';
import { useTheme } from '../../core/ThemeProvider';
import Text from '../Text';
import { Wrapper, TitleWrapper, TitleText, TextWrapper, IconWrapper } from './style';
import { Fade, DURATION } from './animation';
var Accordion = function Accordion(props) {
  var title = props.title,
    desc = props.desc,
    selected = props.selected,
    value = props.value,
    _onClick = props.onClick,
    _props$dividerNeeded = props.dividerNeeded,
    dividerNeeded = _props$dividerNeeded === void 0 ? true : _props$dividerNeeded,
    rest = _objectWithoutProperties(props, _excluded);
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var assignHeight = function assignHeight(node) {
    if (node && !height) {
      setHeight(node.clientHeight);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(TitleWrapper, {
    "data-testid": "titleId",
    onClick: function onClick(event) {
      return _onClick(event, value);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, typeof title === 'string' ? /*#__PURE__*/React.createElement(TitleText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 40
    }
  }, title) : title, /*#__PURE__*/React.createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, resizeIcon(selected ? ArrowUp : ArrowDown))), /*#__PURE__*/React.createElement(Transition, {
    timeout: DURATION,
    "in": selected,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Fade, {
      state: state,
      height: height,
      textMargin: theme.space_4,
      "data-testid": "descriptionId",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(TextWrapper, {
      ref: assignHeight,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 15
      }
    }, typeof desc === 'string' ? /*#__PURE__*/React.createElement(Text, {
      type: "body",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 19
      }
    }, desc) : desc));
  })), dividerNeeded ? /*#__PURE__*/React.createElement(Divider, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 24
    }
  }) : null);
};
Accordion.defaultProps = {
  onClick: noop
};
export default Accordion;